import { Col, Row } from "antd";
import StatCard from "../Dashboard/StatCard";
import { spacing } from "../../theme/tokens";

/**
 * Dải chỉ số của màn danh sách (band 2 của khung 4 dải) — không phải dashboard.
 * Nhận nguyên mảng `stats` theo shape của `StatCard`:
 *   { title, value, icon, color, prefix?, suffix?, trend?, path?, bgColor?, borderColor? }
 *
 * Rỗng thì không render gì (band này là tuỳ màn, có thì hiện).
 */
export default function StatStrip({ stats = [], loading = false, span = { xs: 12, sm: 6 } }) {
  if (!stats.length) return null;

  return (
    <Row gutter={[spacing[4], spacing[4]]} style={{ marginBottom: spacing[4] }}>
      {stats.map((stat, i) => (
        <Col key={stat.title || i} {...span}>
          <StatCard stat={stat} loading={loading} />
        </Col>
      ))}
    </Row>
  );
}
